enum string UserType: PrivateSeller, BusinessSeller, Business, Admin

class User
	string	id
	string	email
	string	name
	string	password
	string	passwordConfirm
	UserType	claimedUserType
	UserType	userType = PrivateSeller
	bool	generalTermsAccepted
	bool	businessTermsAccepted
	string	firstName
	string	lastName
	string	businessName
	string	phoneNumber
	string	streetAddress
	string	zipCode
	string	city
	string	country = "Deutschland"
	bool	emailVisibility = true
	bool	isGuest
	bool	sendEmails = true
	bool	messageForNewAuctions = true
	bool	newUserMessageSent = false
	string[]	rights
	string[]	documents

	inline bool canSeeAuction() (this.userType == Business or this.userType == Admin)

Options
	string[]	values
	string	condition
	string	defaultValue = ""

enum string FilterType: None, Checkboxes, Range
enum string ShowOnHomePage: Never, Always, OneByOne
enum lowercase string DataType: SelectOne = "select one", Toggle, Text, Number, Images, Date

Field
	string	id
	string	name	// The display name of the field
	string	section	// In which selction is the field on the editPage? The sections are displayed in the sidebar.
	string	box	// In which box is the field on the editPage?
	DataType	dataType	// SelectOne, Toggle, Text, Number, Images, ..
	bool	required
	string	unit = ""
	Options[]	options = []
	string	help = ""
	string	description = ""
	string	fieldName

	// Presentation
	float	editOrder, viewOrder
	int	rows = 1
	int	columns = 1
	string[]	showFor	// For which types of goods should this field be shown?
	ShowOnHomePage	showOnHomePage
	bool	showOnEditPage = true
	bool	showInAuctionPageTable = true
	FilterType	filterType = None

	// --- Validation rules ---
	int	minNumber = 0	// Minimum value if the type is number
	int	maxNumber = int.maxValue	// Maximum value if the type is number
	int	minTextLength = 1	// Minimum text length if the type is text
	int	maxTextLength = 100	// Maximum text length if the type is text
	bool	allowCustomValues = false	// If false, the user has to select an option from the options list. If true (or there are no options), they can also enter arbitrary text with a length between minTextLength and maxTextLength.

enum string GoodState: Guest, Draft, Review, Auction, Negotiation, NotSold, Sold

dynamic Good
	string id
	TimeString	created
	TimeString	updated
	TimeString	readyForPickupTime

	// Seller
	GoodState	state	= Guest
	string	seller	= app.user.id

	// Auction
	TimeString	auctionStartTime	// The sever time when the auction starts as a PocketBase time string, e.g. "2025-11-29 19:56:17.329Z"
	TimeString	auctionEndTime	// The sever time when the auction ends as a PocketBase time string, e.g. "2025-11-29 19:56:17.329Z"
	float	currentPrice
	inline bool	isEditable := this.state == Guest or this.state == Draft

	// Sold
	TimeString	sellDate
	TimeString	dueDate
	TimeString	pickupDateBySeller
	TimeString	pickupDateByBuyer
	string	buyer
	float	netPrice
	float	commission
	float	commissionRate
	float	commissionMin
	float	commissionMax
	float	commissionNet
	float	commissionVatRate
	string	cancelationRequestBySeller
	string	cancelationRequestByBuyer

	// Temporary fields (not stored in the database)
	TimeString	order	// Time of the last message or auction end time, used for ordering in buyPage

	// Data
	string	Typ
	string	Name
	float	Preisvorstellung

dynamic Text
	string	kind

enum string ActionType: View, DirectBid, SetAgentLimit, AutomaticBid

dynamic Action
	ActionType	actionType
	string	user	// Relation to users collection
	string	good	// Relation to goods collection
	float	amount
	TimeString	created	// PocketBase auto-generated timestamp
	dynamic	expand	// For expanded relations (e.g. user details)

enum string MessageKind: 
	// Editing
	InReview
	
	// Auction
	HighestDirectBid, AutoBidToBecomeHighest, AutoBidToStayHighest, SavedLimitWhileAlreadyHighest, Outbid, TiedBid, AuctionStarted,

	// Negotiation
	AuctionEndedBelowAskingPrice, ReceivedOfferFromBuyer, ReceivedOfferFromSeller, SendCounterOfferToBuyer, SendCounterOfferToSeller,
	SendDenyToBuyer, SendDenyToSeller, ReceivedDenyFromBuyer, ReceivedDenyFromSeller,

	// Sold
	BuySuccessful, SellSuccessful, CancelationRequest

enum string MessageContext: Edit, Auction, Negotiation, Sold, NotSold
enum string MessageCategory: Ok, Failed, ActionRequired

Message
	string	id
	TimeString	created	// PocketBase auto-generated timestamp
	string	user	// The id of the user receiving the message
	string	good	// The id of good this message is about
	bool	read	// Has the user read the message?
	bool	showPopup	// Should a popup be shown on the auctionPage when the message arrives?
	MessageKind	kind	// InReview, HighestDirectBid, AutoBidToBecomeHighest, AutoBidToStayHighest, SavedLimitWhileAlreadyHighest, Outbid, TiedBid, BuySuccessful, SellSuccessful
	MessageContext	context	// Edit, Auction, Negotiation, Sold, NotSold
	MessageCategory	category	// Ok, Failed, ActionRequired
	string	subject	// The subject of the message, e.g. "Angebot vom Käufer", "Ihr Gegenangebot", "Angebot abgelehnt"
	float	price	// The price mentioned in the message, if any
	string	text	// The first line is the subject, the rest is the message body
	string	goodName	// Usually the "{good.Marke} {good.Modell}", e.g. "Eura Mobil AO 570 HS"
	string	imageUrl	// Relative to backend.url, e.g. "/api/files/goods/rbrrk71pszm0mmc/eura_mobil_xu19lzz423.webp"
